import baustein from "baustein";
import { addVisibilityWatcher } from "web/script/modules/run-loop";
import style from "web/script/dom/style";

export default baustein.register("lazy-image", {
    defaultOptions: {
        imageSrc: null,
        imageSrcset: null,
        isBackgroundImage: false,
    },

    init: function() {
        this.isLoaded = false;
        this._removeVisiblityWatcher = null;
    },

    onInsert: function() {
        if (!this.options.imageSrc && !this.options.imageSrcset) {
            return;
        }

        // Allow images this far outside of the browsers viewport to start loading.
        let loadBelowFoldPx = 800;

        this._removeVisiblityWatcher = addVisibilityWatcher(
            this.el,
            (visible) => {
                if (visible) {
                    this.loadImage();
                    this._removeVisiblityWatcher();
                }
            },
            loadBelowFoldPx
        );
    },

    onRemove() {
        if (this._removeVisiblityWatcher) {
            this._removeVisiblityWatcher();
        }
    },

    loadImage: function() {
        if (!this.options.imageSrc && !this.options.imageSrcset) {
            return;
        }

        this.isLoaded = true;

        if (this.options.isBackgroundImage) {
            style.setStyle(this.el, "background-image", `url(${this.options.imageSrc})`);
        } else {
            if (this.options.imageSrc) {
                this.el.src = this.options.imageSrc;
                this.el.style.visibility = "";
            }

            if (this.options.imageSrcset) {
                this.el.srcset = this.options.imageSrcset;
                this.el.style.visibility = "";
            }
        }
    },
});
